import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { IUserResponse, UserService } from '@olymp/shared';
import { Observable } from 'rxjs';

export const userResolver: ResolveFn<Observable<IUserResponse>> = (
  route,
  state,
) => {
  const userService = inject(UserService);
  return userService.get();
};
